/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ZerogValidatorDelegatorListRequest = {
    validator?: string;
    sortDirection?: ZerogValidatorDelegatorListRequest.sortDirection;
    page?: number;
    size?: number;
};

export namespace ZerogValidatorDelegatorListRequest {

    export enum sortDirection {
        ASC = 'ASC',
        DESC = 'DESC',
    }


}

